/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	Environment,
	EnvironmentDeleteResponse,
	EnvironmentListResponse,
	EnvironmentRequest,
	PraetoidError,
	ProductionAccessRequestBody,
	ProductionAccessRequestResponse
} from '../models';

/**
 * Deletes an environment
 * @summary Delete an environment
 */
export const deleteEnvironment = () => {
	return customInstance<EnvironmentDeleteResponse>({ url: `/environment`, method: 'DELETE' });
};

export const getDeleteEnvironmentMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteEnvironment>>,
		TError,
		void,
		TContext
	>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteEnvironment>>, TError, void, TContext> => {
	const mutationKey = ['deleteEnvironment'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEnvironment>>, void> = () => {
		return deleteEnvironment();
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteEnvironmentMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteEnvironment>>
>;

export type DeleteEnvironmentMutationError = ErrorType<PraetoidError>;

/**
 * @summary Delete an environment
 */
export const useDeleteEnvironment = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteEnvironment>>,
			TError,
			void,
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof deleteEnvironment>>, TError, void, TContext> => {
	return useMutation(getDeleteEnvironmentMutationOptions(options), queryClient);
};
/**
 * Returns the details of a specific environment
 * @summary Get environment details
 */
export const getEnvironment = () => {
	return customInstance<Environment>({ url: `/environment`, method: 'GET' });
};

export const getGetEnvironmentQueryKey = () => {
	return ['environment'] as const;
};

export const getGetEnvironmentQueryOptions = <
	TData = Awaited<ReturnType<typeof getEnvironment>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnvironment>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetEnvironmentQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnvironment>>> = () => getEnvironment();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getEnvironment>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEnvironmentQueryResult = NonNullable<Awaited<ReturnType<typeof getEnvironment>>>;
export type GetEnvironmentQueryError = ErrorType<PraetoidError>;

export function useGetEnvironment<
	TData = Awaited<ReturnType<typeof getEnvironment>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnvironment>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getEnvironment>>,
					TError,
					Awaited<ReturnType<typeof getEnvironment>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEnvironment<
	TData = Awaited<ReturnType<typeof getEnvironment>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnvironment>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getEnvironment>>,
					TError,
					Awaited<ReturnType<typeof getEnvironment>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEnvironment<
	TData = Awaited<ReturnType<typeof getEnvironment>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnvironment>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get environment details
 */

export function useGetEnvironment<
	TData = Awaited<ReturnType<typeof getEnvironment>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnvironment>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetEnvironmentQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Updates an environment's details
 * @summary Update an environment
 */
export const updateEnvironment = (environmentRequest: EnvironmentRequest) => {
	return customInstance<Environment>({
		url: `/environment`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: environmentRequest
	});
};

export const getUpdateEnvironmentMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateEnvironment>>,
		TError,
		{ data: EnvironmentRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateEnvironment>>,
	TError,
	{ data: EnvironmentRequest },
	TContext
> => {
	const mutationKey = ['updateEnvironment'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateEnvironment>>,
		{ data: EnvironmentRequest }
	> = (props) => {
		const { data } = props ?? {};

		return updateEnvironment(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateEnvironmentMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateEnvironment>>
>;
export type UpdateEnvironmentMutationBody = EnvironmentRequest;
export type UpdateEnvironmentMutationError = ErrorType<PraetoidError>;

/**
 * @summary Update an environment
 */
export const useUpdateEnvironment = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateEnvironment>>,
			TError,
			{ data: EnvironmentRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof updateEnvironment>>,
	TError,
	{ data: EnvironmentRequest },
	TContext
> => {
	return useMutation(getUpdateEnvironmentMutationOptions(options), queryClient);
};
/**
 * Creates a new environment for the organization
 * @summary Create a new environment
 */
export const createEnvironment = (environmentRequest: EnvironmentRequest) => {
	return customInstance<Environment>({
		url: `/environment`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: environmentRequest
	});
};

export const getCreateEnvironmentMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createEnvironment>>,
		TError,
		{ data: EnvironmentRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createEnvironment>>,
	TError,
	{ data: EnvironmentRequest },
	TContext
> => {
	const mutationKey = ['createEnvironment'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createEnvironment>>,
		{ data: EnvironmentRequest }
	> = (props) => {
		const { data } = props ?? {};

		return createEnvironment(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateEnvironmentMutationResult = NonNullable<
	Awaited<ReturnType<typeof createEnvironment>>
>;
export type CreateEnvironmentMutationBody = EnvironmentRequest;
export type CreateEnvironmentMutationError = ErrorType<PraetoidError>;

/**
 * @summary Create a new environment
 */
export const useCreateEnvironment = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createEnvironment>>,
			TError,
			{ data: EnvironmentRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof createEnvironment>>,
	TError,
	{ data: EnvironmentRequest },
	TContext
> => {
	return useMutation(getCreateEnvironmentMutationOptions(options), queryClient);
};
/**
 * Sends a production access request to the admin for review
 * @summary Request production access
 */
export const requestProductionAccess = (
	productionAccessRequestBody: ProductionAccessRequestBody
) => {
	return customInstance<ProductionAccessRequestResponse>({
		url: `/environment/request-production`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: productionAccessRequestBody
	});
};

export const getRequestProductionAccessMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof requestProductionAccess>>,
		TError,
		{ data: ProductionAccessRequestBody },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof requestProductionAccess>>,
	TError,
	{ data: ProductionAccessRequestBody },
	TContext
> => {
	const mutationKey = ['requestProductionAccess'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof requestProductionAccess>>,
		{ data: ProductionAccessRequestBody }
	> = (props) => {
		const { data } = props ?? {};

		return requestProductionAccess(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type RequestProductionAccessMutationResult = NonNullable<
	Awaited<ReturnType<typeof requestProductionAccess>>
>;
export type RequestProductionAccessMutationBody = ProductionAccessRequestBody;
export type RequestProductionAccessMutationError = ErrorType<PraetoidError>;

/**
 * @summary Request production access
 */
export const useRequestProductionAccess = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof requestProductionAccess>>,
			TError,
			{ data: ProductionAccessRequestBody },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof requestProductionAccess>>,
	TError,
	{ data: ProductionAccessRequestBody },
	TContext
> => {
	return useMutation(getRequestProductionAccessMutationOptions(options), queryClient);
};
/**
 * Returns all environments for the organization
 * @summary List organization's environments
 */
export const listEnvironments = () => {
	return customInstance<EnvironmentListResponse>({ url: `/environments`, method: 'GET' });
};

export const getListEnvironmentsQueryKey = () => {
	return ['environments'] as const;
};

export const getListEnvironmentsQueryOptions = <
	TData = Awaited<ReturnType<typeof listEnvironments>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnvironments>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListEnvironmentsQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listEnvironments>>> = () =>
		listEnvironments();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listEnvironments>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEnvironmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listEnvironments>>>;
export type ListEnvironmentsQueryError = ErrorType<PraetoidError>;

export function useListEnvironments<
	TData = Awaited<ReturnType<typeof listEnvironments>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnvironments>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listEnvironments>>,
					TError,
					Awaited<ReturnType<typeof listEnvironments>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEnvironments<
	TData = Awaited<ReturnType<typeof listEnvironments>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnvironments>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listEnvironments>>,
					TError,
					Awaited<ReturnType<typeof listEnvironments>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEnvironments<
	TData = Awaited<ReturnType<typeof listEnvironments>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnvironments>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List organization's environments
 */

export function useListEnvironments<
	TData = Awaited<ReturnType<typeof listEnvironments>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnvironments>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListEnvironmentsQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}
